<template>
    <div class="reporting-chart-bar">
        <highcharts :options="chartOptions"/>
    </div>
</template>

<script>
import ChartConsts from '@/providers/ChartConsts'
import * as _ from 'lodash'

export default {
    name: 'ReportingChartBar',
    props: {
        title: String,
        data: Array,
        seriesName: String,
    },
    computed: {
        chartOptions () {
            return this.getBaseOptions()
        },
        categories() {
            if (this.data[0]) {
                return _.map(this.data[0].data, (category) => {
                    return category[0]
                })
            }
            return []
        },
        series() {
            return _.map(this.data, (category) => {
                return {
                    name: category.name,
                    data: _.map(category.data, (val) => {
                        return val[1]
                    })
                }
            })
        }
    },
    methods: {
        getBaseOptions () {
            return {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'column'
                },
                xAxis: {
                    categories: this.categories
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Compliance'
                    }

                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                legend: { enabled: true },
                title: {
                    text: this.title
                },
                credits: { enabled: false },
                colors: ChartConsts.colors,
                series: this.series
            }
        }
    }
}
</script>
